/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { matchSelectableGuide, useCurrentGuide } from "@packages/media";
import { ModalTab, ProfileIcon } from "@packages/ui";

import type { MediaMenuTabProps } from "../MediaMenu.emotion";

export const SelectGuideTab = ({ disabled }: MediaMenuTabProps) => {
  const t = useTranslations();
  const { currentItem, guides } = useCurrentGuide();

  return (
    <ModalTab
      key={"guideSelectMenuTab"}
      value={"guideSelectMenu"}
      label={t("track_settings_guide")}
      startIcon={<ProfileIcon />}
      disabled={disabled}
    >
      {guides.find((g) =>
        matchSelectableGuide(g.guide_ids, currentItem.selected_audio.guide_ids),
      )?.name ?? t("general_word_error")}
    </ModalTab>
  );
};
